import { arrayFromXToYInclusive } from './utils';

export const getNightsOptions = (channelId) => {
  switch (channelId) {
    case 'ukcaravan':
      return [2, 3, 4, 5, 6, 7, 10, 11, 14];
    case 'uktouring':
      return arrayFromXToYInclusive(1, 21);
    case 'boats':
      return [3, 4, 5, 6, 7, 8, 9, 10, 11, 14];
    case 'eurocaravan':
      return [3, 4, 7, 14];
    case 'ukcottages':
      return [...arrayFromXToYInclusive(1, 14), 21];
    default:
      return [2, 3, 4, 7, 10, 11, 14];
  }
};
